import { Col, Row } from "antd";
import { FunctionComponent } from "react";

interface CenterDivProps {
  children?: React.ReactNode;
}

const CenterDiv: FunctionComponent<CenterDivProps> = ({ children }) => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{ height: "100vh" }} // Full height of the viewport
    >
      <Col>
        <div style={{ textAlign: "center" }}>{children}</div>
      </Col>
    </Row>
  );
};

export default CenterDiv;
